import { Position } from "@/models/positions.model";
import { TeamMember } from "@/models/team-member.model";
import { Team } from "@/models/team.model";
import { Module } from "vuex";
import { RootState } from "..";
import { PaginationMeta } from "../../models/pagination.model";
import { actions } from "./teams.actions";
import { mutations } from "./teams.mutations";

export interface TeamsState {
  teams: Team[];
  team: Team;
  teamMembers: TeamMember[];
  teamMember?: TeamMember;
  paginationMeta?: PaginationMeta;
}

export const getInitialState = (): TeamsState => ({
  teams: [],
  team: { name: "", uniform_color: "", uniform_color_hex: "#000000", facebook_profile: undefined, logo_path: undefined },
  teamMembers: [],
  teamMember: undefined,
  paginationMeta: null
});

const state: TeamsState = getInitialState();

export const namespaceTeams = "teams";

export const teamsModule: Module<TeamsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: {
    teamMembersByPosition: state => (position: Position) => {
      const filterFunc = (teamMember: TeamMember): boolean => {
        const matchPositionPredicate = teamMember.position.id === position.id;

        // Return players without position together with midfielders
        if (position.code === "midfield") {
          return matchPositionPredicate || !teamMember.position;
        } else {
          return matchPositionPredicate;
        }
      };

      return state.teamMembers.filter(filterFunc);
    }
  }
};

export * from "./teams.actions";
export * from "./teams.mutations";
